import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setCompensacaodeHoras(params: Params): CustomFormQuestion[] {
  const { questions } = params

  const periodo2Visibility = false
  const periodo3Visibility = false

  const filteredQuestions = questions.filter((question) => {
    const questionAboutPeriod = question.title?.includes('PERÍODO')
    const match = question.title?.match(/PERÍODO (\d+) -/)
    let number = null

    if (questionAboutPeriod) {
      if (match) {
        number = parseInt(match[1], 10)
      }
    }

    //PERIODO 1
    if (question.title == 'PERÍODO 1 - Duração') {
      return true
    }

    //PERIODO 2
    if (number == 2 && !periodo2Visibility) {
      return false
    }

    if (question.title == 'PERÍODO 2 - Duração') {
      return true
    }

    //PERIODO 3
    if (number == 3 && !periodo3Visibility) {
      return false
    }

    //PERIODO 3
    if (number == 3 && !periodo3Visibility) {
      return false
    }

    if (question.title == 'PERÍODO 3 - Duração') {
      return true
    }

    return true
  })

  return filteredQuestions
}
